<template>
  <div class="voyage-info-panel">
    <div v-if="loading" class="loading-state">
      <b-spinner label="Loading..." variant="primary"></b-spinner>
      <p class="loading-text text-secondary">Loading voyage details...</p>
    </div>

    <div v-else-if="!voyage" class="not-found-state">
      <p class="text-secondary">Voyage not found.</p>
    </div>

    <div v-else class="voyage-info-content">
      <div class="d-flex justify-content-between align-items-center mb-2 pb-2 border-bottom">
        <h4 class="section-title text-primary font-weight-bold mb-0">Voyage Information</h4>
      </div>

      <div class="info-grid">
        <div class="info-item">
          <span class="info-label text-secondary font-weight-medium">Asset:</span>
          <span class="info-value text-dark">{{ getAssetName() }}</span>
        </div>
        <div class="info-item">
          <span class="info-label text-secondary font-weight-medium">Voyage Name:</span>
          <span class="info-value text-dark">{{ voyage.mvygName || 'N/A' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label text-secondary font-weight-medium">Voyage No.:</span>
          <span class="info-value text-dark">{{ voyage.mvygNumber || 'N/A' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label text-secondary font-weight-medium">Duration:</span>
          <span class="info-value text-dark">
            <span>{{ voyage.mvygStartTime ? formatIndonesianDate(voyage.mvygStartTime) : 'N/A' }}</span>
            <i class="ri-arrow-right-line mx-2 text-secondary"></i>
            <span>{{ voyage.mvygEndTime ? formatIndonesianDate(voyage.mvygEndTime) : 'N/A' }}</span>
          </span>
        </div>
        <div class="info-item">
          <span class="info-label text-secondary font-weight-medium">Route:</span>
          <span class="info-value text-dark">
            <span>{{ getOriginDisplayName() }}</span>
            <i class="ri-arrow-right-line mx-2 text-secondary"></i>
            <span>{{ getDestinationDisplayName() }}</span>
          </span>
        </div>
        <div class="info-item">
          <span class="info-label text-secondary font-weight-medium">Cargo Status:</span>
          <span class="info-value text-dark">{{ voyage.mvygCargoStatus ? 'With Cargo' : 'No Cargo' }}</span>
        </div>
        <div v-if="voyage.mvygCargoStatus" class="info-item">
          <span class="info-label text-secondary font-weight-medium">Cargo Load:</span>
          <span class="info-value text-dark">{{ voyage.mvygCargoLoadKg || '0' }} kg</span>
        </div>
        <div v-if="voyage.mvygCargoStatus" class="info-item">
          <span class="info-label text-secondary font-weight-medium">Cargo Type:</span>
          <span class="info-value text-dark">{{ voyage.mvygCargoType || 'N/A' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label text-secondary font-weight-medium">Note:</span>
          <span class="info-value text-dark">{{ voyage.mvygNote || 'N/A' }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useVoyageFormatters } from '@/views/voyage/composables/useVoyageFormatters';

export default {
  name: 'VoyageInfoPanel',
  props: {
    voyage: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const {
      formatIndonesianDate,
    } = useVoyageFormatters();

    return {
      formatIndonesianDate,
    };
  },
  methods: {
    getAssetName() {
      return this.voyage?.mvygMass?.massName || 'N/A';
    },
    getOriginDisplayName() {
      return this.voyage?.mvygOriginLndm?.lndmName || 'N/A';
    },
    getDestinationDisplayName() {
      return this.voyage?.mvygDestinationLndm?.lndmName || 'N/A';
    },
  },
};
</script>

<style scoped>
.voyage-info-panel {
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 0.375rem;
  padding: 0.75rem;
}

.loading-state {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  gap: 1rem;
}

.not-found-state {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}

.info-grid {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0.25rem 0;
  border-bottom: 1px solid #f8f9fa;
}

.info-item:last-child {
  border-bottom: none;
}

.info-label {
  flex: 0 0 40%;
  text-align: left;
  font-size: 0.85rem;
}

.info-value {
  flex: 0 0 55%;
  text-align: right;
  word-break: break-word;
  font-size: 0.85rem;
}

.font-weight-medium {
  font-weight: 500;
}
</style>
